module.exports = __webpack_public_path__ + "static/media/retirement-object-3-1-1.983ee0fb.svg";